import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 48 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.5888 22.2918V25.4155L13.0267 23.4625L21.7888 16.4429C22.0503 16.291 22.2427 16.2211 22.3712 16.1927C22.3738 16.1922 22.3763 16.1916 22.3788 16.1911V22.2918V25.4155L24.8167 23.4625L33.5788 16.4429C33.8403 16.291 34.0327 16.2211 34.1612 16.1927C34.1638 16.1922 34.1663 16.1916 34.1688 16.1911V22.2918V25.4155L36.6067 23.4625L45.359 16.4507C45.6378 16.2948 45.8324 16.2265 45.9588 16.1974V43.9551C45.9588 44.3775 45.8277 44.6793 45.5415 44.9559C45.2328 45.2542 44.9137 45.3801 44.5113 45.3801H3.24633C2.81009 45.3801 2.50052 45.2455 2.22153 44.9612L1.15414 46.0085L2.22153 44.9612C1.92138 44.6553 1.79883 44.3441 1.79883 43.9551V3.00508C1.79883 2.58268 1.92996 2.28085 2.21617 2.00429C2.5249 1.70598 2.84393 1.58008 3.24633 1.58008H9.14133C9.54373 1.58008 9.86276 1.70598 10.1715 2.00429C10.4577 2.28085 10.5888 2.58268 10.5888 3.00508V22.2918Z",
      stroke: "currentColor",
      "stroke-width": "3"
    }, null, -1)
  ]))]))
}
export default { render: render }